import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "./useHandleError";
import { getAuthToken } from "../token";

// Share one in-flight request between all callers (provider + page mount together),
// so the list is fetched once per page load instead of once per caller.
let inflightRequest = null;
let inflightToken = null;

export function fetchRealAccounts() {
  const token = getAuthToken();
  if (!inflightRequest || inflightToken !== token) {
    const request = axios
      .get(`${BASE_URL}/MT5M/real_accounts_number_list`, { headers: getApiHeaders() })
      .finally(() => {
        if (inflightRequest === request) {
          inflightRequest = null;
          inflightToken = null;
        }
      });
    inflightRequest = request;
    inflightToken = token;
  }
  return inflightRequest;
}

export function useRealAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const handleError = useHandleError();

  useEffect(() => {
    const fetchAccounts = async () => {
      setLoadingAccounts(true);
      try {
        const res = await fetchRealAccounts();
        if (res.data.code === 200) {
          setAccounts(res.data.data || []);
        } else {
          setAccounts([]);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingAccounts(false);
      }
    };
    
    fetchAccounts();
  }, [handleError]);

  return { accounts, loadingAccounts };
}
